export default __webpack_public_path__ + "static/media/login-logo.8754ebeb.png";